const CONSTANTS = {
    API_HOST: "https://api.4k4matic-panel.info/",
    // API_HOST: "http://192.168.8.167:44000/",
};

export default CONSTANTS;
